module.exports = __webpack_public_path__ + "img/insec_killed.7c51ff35.svg";